import React from 'react';
import { CTABlock, Icon, Paper } from 'library';

import './CTABlock.scss';

const WPCTABlock = ({ data }) => {
  const { heading, text, button, hasDivider, width } = data.block.blockFields.centeredCtaBlock[0];
  const [{ hasLinkArrow, url, style }] = button;

  let { themeOverride } = data;
  if (themeOverride === 'none') {
    themeOverride = null;
  }

  let theme = data.block.blockFields.theme;
  if (theme === 'none') {
    theme = 'plain';
  }

  const buttonLabel =
    (style === 'link' || style === 'text') && hasLinkArrow ? (
      <span>
        {button[0].text} <Icon name="arrow-right" pullRight />
      </span>
    ) : (
      button[0].text
    );

  return (
    <Paper theme={themeOverride ? themeOverride : theme} divider={hasDivider}>
      <div className="CTABlockContainer" style={{ maxWidth: width, margin: '0 auto' }}>
        <CTABlock title={heading} text={text} buttonLabel={buttonLabel} buttonLink={url} buttonTheme={style} />
      </div>
    </Paper>
  );
};

export default WPCTABlock;
